export const DB_NAME = 'offlineDB';
export const DB_VERSION = 3;

export const STORES = {
  MENU_TABLE: 'menuCategory',
  TABLE_STORE: 'diningTables',
  ORDER_STORE: 'orderTables',
  ORDER_CREATION_STORE: 'orderCreationStore',
  VENDOR_STORE: 'vendor',
  PRINTER_STATION_STORE: 'printerStationStore',
  DEFAULT_DESCRIPTION_STORAGE: 'defaultDescriptionStorage',
  POS_TERMINAL_STORAGE: 'posTerminalStorage',
} as const;

export const initDB = (): Promise<IDBDatabase> =>
  new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);

    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;

      if (!db.objectStoreNames.contains(STORES.MENU_TABLE)) {
        db.createObjectStore(STORES.MENU_TABLE, { keyPath: 'id' });
      }

      if (!db.objectStoreNames.contains(STORES.TABLE_STORE)) {
        db.createObjectStore(STORES.TABLE_STORE, { keyPath: 'id' });
      }

      if (!db.objectStoreNames.contains(STORES.ORDER_STORE)) {
        db.createObjectStore(STORES.ORDER_STORE, { keyPath: 'id' });
      }

      if (!db.objectStoreNames.contains(STORES.ORDER_CREATION_STORE)) {
        db.createObjectStore(STORES.ORDER_CREATION_STORE, { keyPath: 'id' });
      }

      if (!db.objectStoreNames.contains(STORES.VENDOR_STORE)) {
        db.createObjectStore(STORES.VENDOR_STORE, { keyPath: 'id' });
      }

      if (!db.objectStoreNames.contains(STORES.PRINTER_STATION_STORE)) {
        db.createObjectStore(STORES.PRINTER_STATION_STORE, { keyPath: 'id' });
      }

      if (!db.objectStoreNames.contains(STORES.DEFAULT_DESCRIPTION_STORAGE)) {
        db.createObjectStore(STORES.DEFAULT_DESCRIPTION_STORAGE, { keyPath: 'id' });
      }

      if (!db.objectStoreNames.contains(STORES.POS_TERMINAL_STORAGE)) {
        db.createObjectStore(STORES.POS_TERMINAL_STORAGE, { keyPath: 'id' });
      }
    };
  });
